/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function X({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M12.424 4.424a.6.6 0 0 0-.848-.848L8 7.15 4.424 3.576a.6.6 0 1 0-.848.848L7.15 8l-3.575 3.576a.6.6 0 0 0 .848.848L8 8.85l3.576 3.575a.6.6 0 0 0 .848-.848L8.85 8l3.575-3.576Z" /></svg>;
}
;